<template>
    <header id="collection-header" :class="{disabled: mobileMenuActive}">
        <div class="container-fluid">
            <div class="header-logo">
                <a href="/">
                    <img src="/img/logo_animate_dark.gif" alt="Store Glide" class="logo">
                    <img src="/img/logo_strgld_dark.gif" alt="Store Glide" class="mobile-logo"/>
                </a>
            </div>
            <div class="wrapper-controls">
                <base-drop-down-menu label="Collections" white>
                    <base-drop-down-item link="/live" label="Live view" active />
                    <base-drop-down-item link="/top" label="Top charts" />
                    <base-drop-down-item link="/collections" label="Collections" />
                </base-drop-down-menu>
            </div>
            <div class="wrapper-panel">
                <custom-drop-down :image="avatar" id="profile" @click="openProfile" :is-open="profileActive" v-if="authUser">
                    <profile-drop-down-item :email="email" />
                </custom-drop-down>
                <form id="login-form" v-else>
                    <button type="button" data-toggle="modal" data-target="#loginModal" class="btn login-btn">Log in</button>
                </form>
            </div>
            <div class="mobile-control">
                <button><img src="/img/header_burger_white.svg" alt="" @click.prevent="openMobileMenu"></button>
            </div>
        </div>
    </header>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import BaseDropDownMenu from '../ui/BaseDropDownMenu';
import BaseDropDownItem from '../ui/parts/BaseDropDownItem';
import CustomDropDown from "../ui/CustomDropDown";
import ProfileDropDownItem from "../ui/parts/ProfileDropDownItem";

export default {
    inheritAttrs: false,
    name: 'collection-header',
    components: {
        BaseDropDownMenu,
        BaseDropDownItem,
        CustomDropDown,
        ProfileDropDownItem
    },
    computed: mapGetters(['profileActive', 'mobileMenuActive']),
    data() {
        return {
            authUser: window.authUser,
            avatar: window.avatar,
            email: window.email
        };
    },
    methods: {
        ...mapMutations([
            'toggleProfileActive',
            'setMobileMenuActive'
        ]),
        openMobileMenu() {
            document.documentElement.classList.add('blocked')
            document.body.classList.add('blocked')
            this.setMobileMenuActive();
        },
        openProfile() {
            this.toggleProfileActive();
        },
    }
};
</script>

<style lang="scss">
    #collection-header {
        position: relative;
        background: linear-gradient(99.26deg, rgba(36, 0, 255, 0) 3.48%, rgba(170, 0, 230, 0.28) 49.55%, rgba(255, 0, 199, 0.65) 98.6%), #200033;
        height: 60px;
        margin-bottom: 40px;
        padding: 0 40px;
        text-align: center;
        width: 100%;
        z-index: 500;
        transition: transform .35s ease 0s;
        display: flex;
        top: 0;
        &.disabled {
            display: none;
        }
        .container-fluid {
            align-items: center;
            .wrapper-controls {
                display: inline-block;
            }
        }
        .wrapper-controls {
            &.xs {
                display: none;
            }
        }
        .wrapper-panel {
            #profile {
                button {
                    .image {
                        width: 34px;
                        border-radius: 40px;
                        border: 2px solid #9240F5;
                    }
                }
            }
        }
        .close-filter {
            background: transparent;
            border: none;
            outline: none;
        }
    }

    @media only screen and (max-width: 991px) {
        #collection-header {
            #login-form {
                display: none;
            }
            padding: 0;
            position: fixed;
            .wrapper-panel {
                display: none;
            }
        }
    }

    @media only screen and (max-width: 500px) {
        #collection-header {
            .mobile-logo {
                width: 75px;
            }
            .wrapper-controls {
                .drop-down {
                    button {
                        font-size: 16px;
                    }
                    .menu {
                        .item {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>

